import React from 'react';
import Hero from '../components/Hero';
import TimeImpact from '../components/TimeImpact';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <TimeImpact />
    </div>
  );
};

export default HomePage;

